/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { getBlocks } from '../reducers/edito';
import EditoApp from 'edito/App';
import * as EditoActions from '../actions/edito';

type Props = {
  blocks: Array<EditorialBlock>,
  updateBlocks: (blocks: Array<EditorialBlock>) => void,
};

const mapStateToProps = state => ({
  blocks: getBlocks(state),
});

const EditoCard = ({ blocks, updateBlocks }: Props) => (
  <EditoApp
    fetchTemplatesUrl="/mc/calendar/flow/templates.json"
    mode="production"
    blocks={blocks}
    onUpdate={updateBlocks}
    attached
  />
);

export default connect(mapStateToProps, {
  updateBlocks: EditoActions.updateBlocks,
})(EditoCard);



// WEBPACK FOOTER //
// ./src/modules/calendar/components/EditoCard.js